'use strict';


//import Katalyo from '../../0001_index/angularJS/index.js';
/*
var moduleName='indexCtrls';
export default moduleName;
var module = angular.module(moduleName);
*/

export default function appController ($scope,$window,GridsterService,MenuService) {
        
      
        $scope.CTRLNAME='appController';
        $scope.gsrvc = GridsterService;
        $scope.menu_service = MenuService;
        var padForB = $scope.gsrvc.getPaddingForBody();
        $scope.activity={
        activityMessage : ""
        };
        
         $scope.ac={
         alerts : []
         }; //{dt:"",message:"",type:"",show:false}
        
        $scope.showActivity = function (msg) {
            setTimeout(function () {
            
              $scope.activity.activityMessage = msg;
              
             });
         
        };
        
        $scope.multiSelectKeyUpDown = function (ev,id) {
          var code = ev.keyCode || ev.which;
          var key = ev.key;
          var elem=$window.document.getElementById(id);
         
             //enter
             if ((key==='p' || key==='P' || key==='b' || key==='B') && ev.ctrlKey)
             {
                ev.preventDefault();
                $scope.$broadcast("CtrlPBPressed",key);
             }
             
             /*
              if (code==13){
                //select elemnt in focus
                   
              }
              //keyup
              if (code==38){
                //move focus to next element
                 ev.preventDefault();
                 elem.next().focus(); 
              }
              //keydown
              if (code==40){
                //move focus to previous element
                 ev.preventDefault();
                 elem.previous().focus(); 
              }
              */
        }
       
};
appController.$inject = ['$scope','$window','GridsterService','MenuService'];

export function homeNavbarCtrl($scope,$rootScope,$state) {
        //$scope.navbar = "/static/modules/0001_index/angularTemplates/navbar.html";
       $scope.CTRLNAME='homeNavbarCtrl';
    };

homeNavbarCtrl.$inject = ['$scope','$rootScope','$state'];
    
export function errorNotFoundCtrl ($scope,$rootScope,$state,$stateParams) {
        //$scope.navbar = "/static/modules/0001_index/angularTemplates/navbar.html";
        //$scope.previousPage=$stateParams.fromState;
        $scope.params = $state.params;
        $scope.CTRLNAME='errorNotFoundCtrl';
};

errorNotFoundCtrl.$inject = ['$scope','$rootScope','$state','$stateParams'];


export function homeCtrl($scope, $rootScope,$state,$cookies,KatalyoStateManager,ProcessingService,MessagingService,CodesService,AuthenticationService,MenuService,ResourcesDataService,TaskDataService,GridsterService,$timeout,$stateParams){
        
     
        $scope.CTRLNAME='homeCtrl';
        $rootScope.headTitle ="Katalyo | Home";
        $scope.currentState=$state.current.name;
        $scope.selectedApp = {'name':''}
        $scope.localVars = {};
        $scope.fd={};
        $scope.taskDefinition={};
        var lang = $rootScope.globals.currentUser.lang;
        $scope.currentUserFirstName=$rootScope.globals.currentUser.first_name;
        $scope.extendedUser = angular.copy($rootScope.globals.currentUser.uep);
        $scope.resource={};
        $scope.resource_page_size=12;
        if ($scope.extendedUser==undefined) $scope.extendedUser = {};
        
        $scope.menu_service = MenuService;
        
        $scope.gsrvc=GridsterService;
        
        $scope.openedTaskInNewPage={localVars:null,taskDefinition:null};
    
        $scope.openTaskInNewPage=function(){
        
                $scope.openedTaskInNewPage = $scope.gsrvc.getTaskDataInNewPage();
        };
        
        $scope.localVars.loadedTasks=[];
        
        $scope.extendedUser.taskDefinitions = [];
        
      
      $scope.LoadTasks = function()
      {
        if ($scope.extendedUser.TaskListHome!=undefined)
        {
                $scope.localVars.loadedTasks.length = 0;
        
                for (var i=0;i<$scope.extendedUser.TaskListHome.length;i++)
                {
                    var localVars = {'isInlineTask':$scope.localVars.isInlineTask,'taskIndex':$scope.localVars.loadedTasks.length,'loadTaskDirect' : true,'taskId':$scope.extendedUser.TaskListHome[i].id,'outcomeId':0,'previousTask':0};
                    $scope.localVars.loadedTasks.push({'taskId':$scope.extendedUser.TaskListHome[i].id,'outcomeId':0,'previousTask':0,'localVars':localVars});
                      
                }
        }
      };
      $scope.LoadTasks();
        //get apps
        $scope.getApps = function()
        {
            ResourcesDataService.GetResourceSubscriptions('application').then(function (data) {
                               
                          $scope.appList =data.data;
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
          
        }
        
        /*$scope.getAllApps = function()
        {
          ResourcesDataService.getResourceDefByType(lang,'application').then(function (data) {
                               
                          $scope.appListFull =data.data;
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        
        }*/
        $scope.params={showAppList:1,subscribing:false};
        $scope.getApps();
        
         $scope.loadApp = function(app)
        {
                
                ResourcesDataService.getResourceDefByType(lang,'application').then(function (data) {
                               
                          $scope.appListFull =data.data;
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
                /*
                AuthenticationService.SetMenusForApp(app).then(function(data) {
                                      
                   MessagingService.addMessage('#'+app.name+' launched successfuly!','success');
                  
                 },function(error){
                  MessagingService.addMessage(error.msg,'error');  
                 });
                 */
        };
        
         $scope.subscribe_unsubscribe = function(app,index,sub_type)
        {
                app.subscribing=true;
                
                ResourcesDataService.ManageResourceSubscriptions(app,'application',sub_type).then(function (data) {
                               
                          MessagingService.addMessage(data.data.msg,'success');
                          app.subscribing=false;
                          $scope.appList[index].resourcesubscriptions_set[0]=data.data.data;
                          
                },function(error){
                              
                              if (error.data['msg']!=undefined) MessagingService.addMessage(error.data.msg,'error');
                              else MessagingService.addMessage(error.data,'error');
                              app.subscribing=false;
                });
                
        }
        
        $scope.getResourceDef = function(pageNumber,pageSize){
   
                
                $scope.resource_page_size = pageSize;
                $scope.resourceLoading=true;
            
                var filter=$scope.resource;
                 
                if ($scope.totalCount>0){
                    if (Math.ceil($scope.totalCount/pageSize)<newPage)
                    {
                      newPage = Math.ceil($scope.totalCount/pageSize);
                    }
                 }

        
                ResourcesDataService.getResourceDefFiltered(pageNumber,pageSize,filter,lang).then(function(data) {
      
                                $scope.firstQuery=true;
                                $scope.resourceData = data.data.results;
                                $scope.nextPage = data.data.next;
                                $scope.previousPage = data.data.previous;
                                $scope.totalItemCount=data.data.count;
                                $scope.currentPage=pageNumber;
                                $scope.numberOfPages = Math.ceil($scope.totalItemCount/pageSize);
                                
                                if (($scope.totalItemCount<=pageSize && $scope.resourceData.length>0) || $scope.totalItemCount==0) $scope.hideBtnMore = true;
                                else $scope.hideBtnMore=false;
                                
                                $scope.resourceLoading=false;
                                
                                },function(error){
       
                                 MessagingService.addMessage(error.msg,'error');
                                 $scope.resourceLoading=false;
                             });
        };
        $scope.loadMoreResource = function(){
                $scope.resource_page_size = $scope.resource_page_size+12;
                $scope.getResourceDef(1,$scope.resource_page_size);        
                
        }
        $scope.saveHomePage = function()
        {
          
           MenuService.saveHomePage($scope.extendedUser).then(function(data) {
                         $rootScope.globals.currentUser.uep = data.data;
                         $cookies.put('globals', $rootScope.globals);
                         $scope.extendedUser = $rootScope.globals.currentUser.uep;
                         $scope.LoadTasks();
                          MessagingService.addMessage(data.msg,'success');
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };
        
        
               ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
        
                                   $scope.taskList = data.data;
                                  
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                                 
                            });
        
    }
    
homeCtrl.$inject = ['$scope', '$rootScope','$state','$cookies','KatalyoStateManager','ProcessingService','MessagingService','CodesService','AuthenticationService','MenuService','ResourcesDataService','TaskDataService','GridsterService','$timeout','$stateParams'];
    
export function onboardingCtrl ($scope, $rootScope,$state,$cookies,KatalyoStateManager,ProcessingService,MessagingService,CodesService,AuthenticationService,MenuService,ResourcesDataService,TaskDataService,GridsterService,$timeout,$stateParams){

        $scope.CTRLNAME='onboardingCtrl';
        $rootScope.headTitle ="Katalyo | Onboarding";
        $scope.currentState=$state.current.name;
        $scope.selectedApp = {'name':''}
        $scope.localVars = {};
        $scope.fd={};
        $scope.taskDefinition={};
        $scope.localVars.pageLoaded=false;
        var lang = $rootScope.globals.currentUser.lang;
        $scope.currentUserFirstName=$rootScope.globals.currentUser.first_name;
        $scope.extendedUser = angular.copy($rootScope.globals.currentUser.uep);
        $scope.menu_service = MenuService;
        
        
        $scope.gsrvc=GridsterService;
        
        $scope.openedTaskInNewPage={localVars:null,taskDefinition:null};
    
        $scope.openTaskInNewPage=function(){
        
                $scope.openedTaskInNewPage = $scope.gsrvc.getTaskDataInNewPage();
        };
        
        $scope.localVars.loadedTasks=[];
        
        $scope.extendedUser.taskDefinitions = [];
        
       
     
       $scope.getResourceAll = function () {
          
            ResourcesDataService.getResourceDefAll($scope.extendedUser.Params.OnboardingAppId).then(function(data) {
                               
                             // MessagingService.addMessage(data.msg,'success');
                              $scope.resource = data.data;
                              $scope.application_name=$scope.resource.resourcedeflang_set[0].Name;
                               
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };      
         //get app details
        if ($scope.extendedUser.Params.Onboarding=='AppSetup')
        {
                 $scope.getResourceAll();      
        }

         $scope.localVars.pageLoaded=true;
}


 onboardingCtrl.$inject = ['$scope', '$rootScope','$state','$cookies','KatalyoStateManager','ProcessingService','MessagingService','CodesService','AuthenticationService','MenuService','ResourcesDataService','TaskDataService','GridsterService','$timeout','$stateParams'];

 
 export function demoCtrl ($scope, $rootScope,$state,$cookies,KatalyoStateManager,ProcessingService,MessagingService,CodesService,AuthenticationService,MenuService,ResourcesDataService,TaskDataService,GridsterService,$timeout,$stateParams){

        $scope.CTRLNAME='demoCtrl';
        $rootScope.headTitle ="Katalyo | Demo";
        $scope.currentState=$state.current.name;
        //Login
}


 demoCtrl.$inject = ['$scope', '$rootScope','$state','$cookies','KatalyoStateManager','ProcessingService','MessagingService','CodesService','AuthenticationService','MenuService','ResourcesDataService','TaskDataService','GridsterService','$timeout','$stateParams'];

 
export function navbarCtrl($scope,$rootScope,$state,CodesService,MenuService,$stateParams,$cookies,$timeout,MessagingService){


        $scope.CTRLNAME='navbarCtrl';
        $scope.menu_service = MenuService;
        $scope.menus= {editMode: $scope.menu_service.getMenuEditMode()};
        $scope.logoutLoaded=false;
        $scope.navbarLoaded=true;
        
        $scope.cMenus=[];
        $scope.is_superuser =  $rootScope.globals.currentUser.is_superuser;  
        $scope.cuser =  $rootScope.globals.currentUser.first_name+" "+$rootScope.globals.currentUser.last_name;
        $scope.currentPage = $state.current.name;
        $scope.currentNavbarId = $stateParams.navbar_id;
        $scope.currentSideMenuId = $stateParams.sidemenu_id;
        var lang =  $rootScope.globals.currentUser.lang;
        
        //$scope.menu_service.LoadMenus($scope);
        
        //GET navbars
        $scope.getNavbarItems = function(lang)
        {
           
           $scope.menu_service.getNavbars(lang).then(function (data) {
          
            if ($scope.currentNavbarId==undefined || isNaN($scope.currentNavbarId) || $scope.currentNavbarId===0 || $scope.currentNavbarId==="")
            {
                $scope.currentNavbarId = $scope.getLinkNavbarByName($scope.currentPage);
            }
            
            
            
            if ($scope.menu_service.getMenuEditMode())
            {
              $scope.setEditNavbar($scope.currentEditNavbarId);
             
            }
            else
            {
              $scope.setNavbar($scope.currentNavbarId);
            }
            
             
          });
          
        };
     
     $scope.menu_service.LoadMenus($scope).then(function (data) {
            $scope.getNavbarItems(lang);
            }
            ,function(error){    
                              MessagingService.addMessage(error,'error');
                              
                            
    });
           
    
     
        
      $scope.$watch('menu_service.getMenuEditMode()',function(newValue,oldValue){
                  if (newValue!=oldValue)
                  {
                    if (newValue) $scope.currentEditNavbarId = null;
                    $scope.getNavbarItems(lang);
                  }
      });
       
       //get navbarId by page id
       $scope.getLinkNavbar = function(pageid) {
      
          return  $scope.menu_service.getPageNavbar(pageid,lang);
    
        };
      
      $scope.LoadLogout = function() {
        $timeout(function(){
                $scope.logoutLoaded=true;
        });
        };
      //get navbarId by state name
      $scope.getLinkNavbarByName = function(currentStateName) {
      
          return  $scope.menu_service.getNavbarByTargetName(currentStateName,lang);
    
      };
     
      
    $scope.setSideMenu = function(menuId) {     
      $scope.menu_service.setSelectedSidemenu(menuId) ;
      //$scope.currentSideMenuId=menuId;
    };
      
      //SET current navbarId for editMode=false
      $scope.setNavbar = function(navbarId) {
        $scope.currentNavbarId = navbarId;
        $scope.menu_service.setCurrentNavbarId($scope.currentNavbarId,lang);
        
        //GET child menus
        $scope.cMenus = $rootScope.globals.currentUser.cMenus;
        
        if ($scope.currentSideMenuId>0) $scope.setSideMenu($scope.currentSideMenuId);
      //  $scope.getMenusForNavbar();
      };
    
    //GET navbar definition details
    $scope.getNavbarDetails = function(navbarId,index) {
      $scope.currentEditNavbarIndex=index;
      $scope.setEditNavbar(navbarId);
     // $scope.menu_service.setSelectedNavbar(navbarId);
    }
      
      //SET current navbarId for editMode=true
    $scope.setEditNavbar = function(navbarId) {
      $scope.currentEditNavbarId = navbarId;
      $scope.menu_service.setCurrentNavbarId($scope.currentEditNavbarId,lang);
    }
      
     //generate children navbar right
              
     $scope.checkIfLast = function() {
     
      var rval=true;
      //if ($scope.currentEditNavbarIndex==0) return rval;
      for (var i=$scope.currentEditNavbarIndex+1;i<$scope.menu_service.navbarItems.length;i++)
      {
       if ($scope.menu_service.navbarItems[$scope.currentEditNavbarIndex].MenuPosition.id==$scope.menu_service.navbarItems[i].MenuPosition.id)
        {
          rval= false;
        }
      }
       return rval;
     
    };
    
     $scope.checkIfFirst = function() {
     
      var rval=true;
      if ($scope.currentEditNavbarIndex==0) return rval;
      for (var i=$scope.currentEditNavbarIndex-1;i>=0;i--)
      {
       if ($scope.menu_service.navbarItems[$scope.currentEditNavbarIndex].MenuPosition.id==$scope.menu_service.navbarItems[i].MenuPosition.id)
        {
          rval= false;
        }
      }
       return rval;
     
    };
      
    $scope.moveNavbarLeft = function() {
     
      var element1 =  $scope.menu_service.navbarItems[$scope.currentEditNavbarIndex];
      var newIndex=$scope.currentEditNavbarIndex-1;
      while ($scope.menu_service.navbarItems[$scope.currentEditNavbarIndex].MenuPosition.id!=$scope.menu_service.navbarItems[newIndex].MenuPosition.id && newIndex>0)
      {
        newIndex=newIndex-1;
      }
      
      $scope.menu_service.navbarItems.splice($scope.currentEditNavbarIndex, 1);
      $scope.menu_service.navbarItems.splice(newIndex, 0, element1);
      $scope.currentEditNavbarIndex = newIndex;
     
    };
    $scope.moveNavbarRight = function() {
     
      var element2 =  $scope.menu_service.navbarItems[$scope.currentEditNavbarIndex];
      var newIndex=$scope.currentEditNavbarIndex+1;
      while ($scope.menu_service.navbarItems[$scope.currentEditNavbarIndex].MenuPosition.id!=$scope.menu_service.navbarItems[newIndex].MenuPosition.id && newIndex<$scope.menu_service.navbarItems.length-1)
      {
        newIndex=newIndex+1;
      }
      
      $scope.menu_service.navbarItems.splice($scope.currentEditNavbarIndex, 1);
      $scope.menu_service.navbarItems.splice(newIndex, 0, element2);
      $scope.currentEditNavbarIndex = newIndex;
    };
    
      $scope.setNavbarActive = function(navbarId) {
      if ($scope.navbarLoaded)
      {
      
      return navbarId==$scope.currentNavbarId ? "active" : "";
      }else $scope.setNavbarActive(navbarId);
    }
    
       $scope.newNavbar = function(){
           $scope.currentEditNavbarId = 0;
           $scope.menu_service.newNavbar(lang,'navbar');
       };            
    
        $scope.newChildNavbar = function(){
           $scope.currentEditNavbarId = 0;
           $scope.menu_service.newNavbar(lang,'navbarrightc');
       }; 
    
    $scope.activeLinkEditNavbar = function(navbar) {
      $scope.navbarEdit = null;
      if ($scope.navbarLoaded)
      {
      if ($scope.currentEditNavbarId!=undefined && $scope.currentEditNavbarId!=null)
      {
        $scope.navbarEdit = $scope.currentEditNavbarId;
      }
      return navbar==$scope.navbarEdit ? "active" : "";
      }else $scope.activeLinkEditNavbar(navbar);
    };
    
        $scope.saveNavbarOrder = function()
                
                {
     
                    $scope.menu_service.saveMenuOrder(lang,0).then(function(data) {
                                                                     
                                       MessagingService.addMessage(data.msg,'success');
                                    },function(error){    
                                    MessagingService.addMessage(error.msg,'error');
                              
                                 });
                  
                }; 
    
    $scope.gotoState=function(name,params)
    {
      $state.go(name,{navbarId: params});
      
    };

}

navbarCtrl.$inject = ['$scope', '$rootScope','$state','CodesService','MenuService','$stateParams','$cookies','$timeout','MessagingService'];

export function menuCtrl($scope,$rootScope,$state,CodesService,MenuService,$stateParams,$cookies,MessagingService)
{
 
        $scope.CTRLNAME='menuCtrl';
        $scope.menu_service = MenuService;
        $scope.sideMenuId = $stateParams.sidemenu_id;
        var lang =  $rootScope.globals.currentUser.lang;
        $scope.activeLinkSidemenu = function(n) {
        
          return ($state.current.name.indexOf(n)>=0 ? "active" : "");
      };
      
      $scope.setSideMenu = function(menuId) {
       
        $scope.menu_service.setSelectedSidemenu(menuId) ;
        $scope.currentSideMenuId=menuId;
      };
      

      //GET side menu definition details
      $scope.getSideMenuDetails = function(sidemenuId,index) {
       $scope.currentEditSideMenuIndex=index;
       $scope.currentEditSideMenuId = sidemenuId;
       $scope.setSideMenu(sidemenuId);
      }
      
      $scope.moveMenuUp = function() {
       
        var element = $scope.menu_service.selectedNavbar.SideMenus[ $scope.currentEditSideMenuIndex];
        $scope.menu_service.selectedNavbar.SideMenus.splice( $scope.currentEditSideMenuIndex, 1);
        $scope.menu_service.selectedNavbar.SideMenus.splice( $scope.currentEditSideMenuIndex-1, 0, element);
       $scope.currentEditSideMenuIndex--;
      }
      $scope.moveMenuDown = function() {
       
        var element = $scope.menu_service.selectedNavbar.SideMenus[ $scope.currentEditSideMenuIndex];
        $scope.menu_service.selectedNavbar.SideMenus.splice( $scope.currentEditSideMenuIndex, 1);
        $scope.menu_service.selectedNavbar.SideMenus.splice( $scope.currentEditSideMenuIndex+1, 0, element);
       $scope.currentEditSideMenuIndex++;
      }
      
         $scope.newSideMenu = function(){
             $scope.currentEditSideMenuId = 0;
             $scope.menu_service.newSideMenu(lang);
         }; 
       
       $scope.saveMenuOrder = function()
                  
                  {
       
                      $scope.menu_service.saveMenuOrder(lang,1).then(function(data) {
                                         
                                         $scope.menu_service.setSidemenuOrder(lang);                              
                                         MessagingService.addMessage(data.msg,'success');
                                         
                                      },function(error){    
                                      MessagingService.addMessage(error.msg,'error');
                                
                                   });
                    
                  };
      
       $scope.activeLinkSideByMenuId = function(menuItem) {
          
         return ($scope.currentSideMenuId==menuItem.id ? true : false);
         
      };
      
                   
       $scope.activeLinkSideEditByParams = function(params,menuItem) {
      
          
         return ($scope.currentEditSideMenuId==menuItem.id ? true : false);
      
         
      };
      
      
      if ($scope.sideMenuId!=undefined && $scope.sideMenuId!="" && $scope.sideMenuId!=null)
      {
        $scope.setSideMenu($scope.sideMenuId);
      }


 }
 
 menuCtrl.$inject = ['$scope', '$rootScope','$state','CodesService','MenuService','$stateParams','$cookies','MessagingService'];

export function toolboxCtrl ($scope,GridsterService) {
         $scope.CTRLNAME='toolboxCtrl';
       $scope.gsrvc = GridsterService;
}
toolboxCtrl.$inject =['$scope','GridsterService'];
export function taskToolboxCtrl ($scope,GridsterService) {
        
        $scope.CTRLNAME='taskToolboxCtrl';
        $scope.gsrvc = GridsterService;
       
}
taskToolboxCtrl.$inject = ['$scope','GridsterService'];   

export function signupCtrl($scope,$http,$rootScope,$state,vcRecaptchaService) {
        
       $scope.CTRLNAME='signupCtrl';
       $rootScope.headTitle ="Katalyo | Sign up";
       $scope.signupSuccess = false;
       $scope.hideError="";
       var widgetId;
         $scope.signup = function(){
          
          // var language = $rootScope.globals.currentUser.lang;
           //if (language == undefined) language="en-GB";
           var language = "en-GB";
           $scope.dataLoading=true;
            
            $http({
                method: 'POST',
                url: '../api/signup/',
                headers: { 'Content-Type': 'application/json' },

                data: {'email':$scope.email,'captchaResponse':$scope.captchaResponse}
             
            })
            .then(function (data) {

                    if (data.status === 200) {
                      $scope.signupSuccess = true;
                     
                    } else
                    
                    {
                       $scope.signupSuccess = false;
                      $scope.errorMsg=data.data;
                       vcRecaptchaService.reload(widgetId);
                    }
                    $scope.dataLoading=false;

                },
                function (error) {
                        $scope.dataLoading=false;
                        $scope.signupSuccess = false;
                        $scope.errorMsg=error.data;
                        vcRecaptchaService.reload(widgetId);
                });
				
               
           
          
         };
         
          $scope. onWidgetCreate = function(_widgetId){
                widgetId = _widgetId;
            };
          
          $scope.hideError = function(){
            $scope.errorMsg="";
          };
          
    }

 signupCtrl.$inject =   ['$scope','$http', '$rootScope','$state','vcRecaptchaService'];
 
export function registerCtrl($scope,$http,$rootScope,$state,$stateParams,AuthenticationService,MenuService) {
        
        $scope.CTRLNAME='registerCtrl';
        $rootScope.headTitle ="Katalyo | Register | Onboarding";
        
        //get data from hash and email
        $scope.signupkey=$stateParams.signupid;
        $scope.InvalidRequest=false;
        $scope.checkingSignup=true;
        $scope.signupOK=false;
        $scope.signupCheckDone=false;
        $scope.checkingEOSAccount = false;
        $scope.register={};
        
        $scope.register.organisation_type="ForProfit";
        $scope.register.signup_key=$scope.signupkey;
        
        var weakRegularExp = new RegExp("^(?=.*[a-z])|(?=.*[A-Z])|(?=.*[0-9])|(?=.*[!@#\$%\^&\*\"\(\)\=\?\+\'<>;:,\-\._/\\\\])(?=.{8,})");
        
        var midRegularExp = new RegExp("^((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))(?=.*[!@#\$%\^&\*\"\(\)\=\?\+\'<>;:,\-\._/\\\\])(?=.{8,})");  
               
        var strongRegularExp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\"\(\)\=\?\+\'<>;:,\-\._/\\\\])(?=.{8,})");  
       
        $scope.checkPassword = function(element)
        {
          
          if (!strongRegularExp.test(element.$modelValue)) element.$setValidity("required",false);
        }
       
        $scope.checkSignup = function(){
          
            $http({
                method: 'POST',
                url: '../api/check-signup/',
                headers: { 'Content-Type': 'application/json' },

                data: {'signupkey':$scope.signupkey}
             
            })
            .then(function (data) {

                    if (data.status == 200) {
                   
                    
                       $scope.signupOK = true;
                    }else
                    {
                     $scope.InvalidRequest = true;  
                      
                    }
                    $scope.checkingSignup=false;
                    $scope.signupCheckDone = true;  
                },function (error) {
                       $scope.checkingSignup=false;
                       $scope.InvalidRequest = true;
                       $scope.errorMsg=error.data;
                       $scope.signupCheckDone = true;  
                });
				  
         };
        
        
        $scope.fn_register = function(valid){
          
          if (valid)
          {
            $http({
                method: 'POST',
                url: '../api/register/',
                headers: { 'Content-Type': 'application/json' },

                data: $scope.register
             
            })
            .then(function (data) {

                if (data.status == 200) {
                        //set user info
                        AuthenticationService.SetCredentials(data.data.data, $scope.register.username,$scope.register.password);
                        //load menus
                                MenuService.LoadMenus($scope).then(function () {
                                //go to home page
                                $state.go("app.navbar.home",{});
                        });
                      
                }else
                {
                 
                 $scope.errorMsg = data.data;   
                      
                }
                  
                },function (error) {
                        //show error msg
                        $scope.errorMsg = error.data;   
                        
                });
          }			  
        };
        
        
        
        
        if ($scope.signupkey==undefined || $scope.signupkey=="")
        {
          $scope.signupCheckDone = true;
          $scope.checkingSignup=false;
        }
        else
        {
          
          $scope.checkSignup(); 
          
        }
        
        $scope.eosObject =  { account:''};
         
        $scope.checkEOSAccount = function(){
          
          // var language = $rootScope.globals.currentUser.lang;
           //if (language == undefined) language="en-GB";
           var language = "en-GB";
           $scope.eosObject.lang=language;
           $scope.eosAccountObject={result_code:-1};
          
          	
            $scope.checkingEOSAccount = true;
            
            $http({
                method: 'POST',
                url: 'https://api-prd.eosflare.io/chain/get_account',
                headers: { 'Content-Type': 'application/json' },

                data: $scope.eosObject
             
            })
            .then(function (data) {

                    if (data.status === 200) {
                      if (data.data.err_code==0)
                      {
                        $scope.eosAccountObject=data.data.result;
                        $scope.eosAccountObject.result_code=data.data.err_code;
                        $scope.eosAccountObject.account_name= $scope.eosObject.account;
                        $scope.eosAccountObject.balance_staked_progress= ($scope.eosAccountObject.balance_staked/$scope.eosAccountObject.balance_total*100);
                        if ($scope.eosAccountObject.balance_staked_progress<0.5 && $scope.eosAccountObject.balance_staked_progress) $scope.eosAccountObject.balance_staked_style_small={'min-width':'1%'};
                        $scope.eosAccountObject.balance_unstaked_progress= ($scope.eosAccountObject.balance_unstaked/$scope.eosAccountObject.balance_total*100);
                        if ($scope.eosAccountObject.balance_unstaked_progress<0.5 && $scope.eosAccountObject.balance_unstaked_progress>0) $scope.eosAccountObject.balance_unstaked_style_small={'min-width':'1%'};
                        $scope.eosAccountObject.cpu_limit_progress= ($scope.eosAccountObject.cpu_limit_used/$scope.eosAccountObject.cpu_limit_max*100);
                        if ($scope.eosAccountObject.cpu_limit_progress<0.5 && $scope.eosAccountObject.cpu_limit_progress>0) $scope.eosAccountObject.cpu_style_small={'min-width':'1%'};
                        $scope.eosAccountObject.net_limit_progress= ($scope.eosAccountObject.net_limit_used/$scope.eosAccountObject.net_limit_max*100);
                        if ($scope.eosAccountObject.net_limit_progress<0.5 && $scope.eosAccountObject.net_limit_progress>0) $scope.eosAccountObject.net_style_small={'min-width':'1%'};
                        $scope.eosAccountObject.ram_progress= ($scope.eosAccountObject.ram_usage/$scope.eosAccountObject.ram_quota*100);
                        if ($scope.eosAccountObject.ram_progress<0.5 && $scope.eosAccountObject.ram_progress>0) $scope.eosAccountObject.ram_style_small={'min-width':'1%'};
                     
                        $scope.eosAccountObject.cpu_unit_max="us";
                        $scope.eosAccountObject.net_unit_max="Bytes";
                        $scope.eosAccountObject.ram_unit_quota="Bytes";
                      
                        var convertCpuMax = $scope.convertTime($scope.eosAccountObject.cpu_limit_max);
                      
                        $scope.eosAccountObject.cpu_limit_max=convertCpuMax.size;
                        $scope.eosAccountObject.cpu_unit_max=convertCpuMax.unit;
                      
                        var convertCpuUsed = $scope.convertTime($scope.eosAccountObject.cpu_limit_used);
                      
                        $scope.eosAccountObject.cpu_limit_used=convertCpuUsed.size;
                        $scope.eosAccountObject.cpu_unit_used=convertCpuUsed.unit;
                      
                      
                        var convertNetMax = $scope.convertMemory($scope.eosAccountObject.net_limit_max);
                        
                        $scope.eosAccountObject.net_limit_max=convertNetMax.size;
                        $scope.eosAccountObject.net_unit_max=convertNetMax.unit;
                    
                    
                        var convertNetUsed = $scope.convertMemory($scope.eosAccountObject.net_limit_used);  
                        
                        $scope.eosAccountObject.net_limit_used=convertNetUsed.size;
                        $scope.eosAccountObject.net_unit_used=convertNetUsed.unit;
                    
                    
                        var convertRamQuota = $scope.convertMemory($scope.eosAccountObject.ram_quota);  
                     
                        $scope.eosAccountObject.ram_quota=convertRamQuota.size;
                        $scope.eosAccountObject.ram_unit_quota=convertRamQuota.unit;
                        
                      
                        var convertRamUsage = $scope.convertMemory($scope.eosAccountObject.ram_usage);  
                     
                        $scope.eosAccountObject.ram_usage=convertRamUsage.size;
                        $scope.eosAccountObject.ram_unit_usage=convertRamUsage.unit;
                        
                       
                    }
                    else {
                        $scope.errorMsg=data.err_msg;
                    }
                  }
                      $scope.checkingEOSAccount = false;
                    
                },function (error) {
                    
                    $scope.checkingEOSAccount = false;
                  
                });
				
               $scope.convertMemory = function(sizeInBytes){
                  
                    var convertedMemory={size:0,unit:''};
                     if (sizeInBytes==0)
                    {
                      convertedMemory.size=sizeInBytes;
                      convertedMemory.unit = "";
                    }
                    else if ((sizeInBytes/1024)<0.5)
                    {
                      convertedMemory.size=sizeInBytes;
                      convertedMemory.unit = "Bytes";
                    }
                      else if ((sizeInBytes/1024)<1024)
                      {
                        convertedMemory.size=(sizeInBytes/1024).toFixed(2);
                       
                        convertedMemory.unit ="KB";
                        
                      }
                      else if (sizeInBytes/1024<1024*1024)
                      {
                        convertedMemory.size=(sizeInBytes/1024/1024).toFixed(2);
                       
                        convertedMemory.unit ="MB";
                      }
                      else
                      {
                        convertedMemory.size=(sizeInBytes/1024/1024/1024).toFixed(2);
                    
                        convertedMemory.unit ="GB";
                      }
                  
                    return convertedMemory;
                }; 
           
          
          $scope.convertTime = function(sizeInMicroSec){
                  
                    var convertedTime={size:0,unit:''};
                    if (sizeInMicroSec==0)
                    {
                      convertedTime.size=sizeInMicroSec;
                      convertedTime.unit = "";    
                    }
                    else if ((sizeInMicroSec/1000)<0.01)
                    {
                      convertedTime.size=sizeInMicroSec;
                      convertedTime.unit = "microsec";
                    }
                    else if ((sizeInMicroSec/1000)<1000)
                      {
                        convertedTime.size=(sizeInMicroSec/1000).toFixed(2);
                       
                        convertedTime.unit ="ms";
                        
                      }
                      else if (sizeInMicroSec/1000/1000<1000)
                      {
                        convertedTime.size=(sizeInMicroSec/1000/1000).toFixed(2);
                       
                        convertedTime.unit ="s";
                      }
                      else if (sizeInMicroSec/1000/1000/60<60)
                      {
                        convertedTime.size=(sizeInMicroSec/1000/1000/60).toFixed(2);
                       
                        convertedTime.unit ="min";
                      }
                      else
                      {
                        convertedTime.size=(sizeInMicroSec/1000/1000/60/60).toFixed(2);
                    
                        convertedTime.unit ="h";
                      }
                  
                    return convertedTime;
                }; 
           
          
          
         };
          
    }
    
 registerCtrl.$inject = ['$scope','$http', '$rootScope','$state','$stateParams','AuthenticationService','MenuService'];